<template>
  <div class="limited-width-container">
    <NavigationBar variant="landing" />
    <div class="landing-container">

      <!-- First Section: Hero -->
      <section class="hero">
        <div class="hero-content">
          <h1>Kompakta <span class="">pierakstu sistēma</span> profesionāļiem</h1>
          <h2>Pieņem pierakstus tiešsaistē, automatizē atgādinājumus un atceries katra klienta preferences - sniedz
            servisu, kas rada lojalitāti.</h2>
          <button class="primary-btn" onclick="document.getElementById('how-it-works').scrollIntoView()">
            Uzzināt vairāk
            <PhArrowDown class="button-icon-landing" />
          </button>
        </div>
      </section>

      <!-- Second Section: Feature Blocks -->
      <section class="features-section" id="how-it-works">
        <!-- Block 1 - Text left, visual right -->
        <div class="feature-block">
          <div class="feature-text">
            <div class="text-area-left">
              <div class="feature-icon">
                <PhLink />
              </div>
              <h3>Publicē saiti, nevis atbildi uz ziņām</h3>
              <p>Pievieno saiti uz pierakstu formu savā mājaslapā, instagram profilā un storijos, e-pastos un citur.
              </p>
            </div>
          </div>
          <div class="feature-visual bg-gray">
            <img class="illustration" src="@/assets/illustrations/ilu01.svg"
              alt="Pierakstu saites publicēšana Instagram profilā, mājaslapā vai e-pastos" style="max-width:400px;" />
          </div>
        </div>

        <!-- Block 2 - Visual left, text right -->
        <div class="feature-block">
          <div class="feature-visual bg-blue">
            <img class="illustration" src="@/assets/illustrations/ilu02.svg"
              alt="Klients veic rezervāciju caur tiešsaistes pierakstu formu" />
          </div>
          <div class="feature-text">
            <div class="text-area-right">
              <div class="feature-icon">
                <PhUser />
              </div>
              <h3>Klienti pierakstīsies patstāvīgi</h3>
              <p>Klienti varēs apskatīt pieejamos pakalpojumus un laikus, un veikt pierakstus paši - jebkurā diennakts
                laikā.</p>
            </div>
          </div>
        </div>

        <!-- Block 3 - Text left, visual right -->
        <div class="feature-block">
          <div class="feature-text">
            <div class="text-area-left">
              <div class="feature-icon">
                <PhEnvelopeSimple />
              </div>
              <h3>Tu vienmēr būsi informēts</h3>
              <p>Tu saņemsi paziņojumus par visām būtiskajām izmaiņām - jauniem pierakstiem, pierakstu atcelšanu vai
                pārplānošanu uz citu laiku.
              </p>
            </div>
          </div>
          <div class="feature-visual bg-green">
            <img class="illustration" src="@/assets/illustrations/ilu03.svg"
              alt="Automātiski e-pasta paziņojumi par jaunām rezervācijām, atceltām vai pārplānotām rezervācijām" />
          </div>
        </div>

        <!-- Block 4 - Visual left, text right -->
        <div class="feature-block">
          <div class="feature-visual bg-purple">
            <img class="illustration" src="@/assets/illustrations/ilu04.svg"
              alt="Klients saņem e-pasta atgādinājumu par pierakstu ar opcijām to apstiprināt vai norādīt, ka neieradīsies" />
          </div>
          <div class="feature-text">
            <div class="text-area-right">
              <div class="feature-icon">
                <PhCheck />
              </div>
              <h3>Zini, kas ieradīsies</h3>
              <p>Vienu dienu pirms pieraksta datuma klienti saņems atgādinājumu un varēs apstiprināt savu ierašanos. Tu
                aplikācijā jau laicīgi redzēsi, kurš ierašanos ir apstiprinājis.</p>
            </div>
          </div>
        </div>
      </section>

      <!-- Third Section: Full Width Different Background -->
      <div class="cta-container" id="pricing">
        <section class="cta-section">
          <div class="cta-content">
            <h1>Pagaidām bez maksas</h1>
            <p>Aplikācija ir nesen sākusi darbību un pagaidām ir pieejama bez maksas.</p>
          </div>
          <div class="cta-button-column">
            <router-link to="/register" style="text-decoration: none;">
              <button class="primary-btn"
                style="padding-left: 40px; padding-right: 40px; color: var(--background-color);">
                Izmēģināt
                <PhArrowRight class="button-icon-landing" />
              </button>
            </router-link>
          </div>
        </section>
      </div>

      <!-- Fourth Section: Pricing -->
      <section class="pricing">
        <div class="pricing-header">
          <h2>Cenas</h2>
          <p class="pricing-subtitle">*stāsies spēkā tuvākajos mēnešos</p>
        </div>

        <div class="pricing-cards">
          <div class="pricing-card first">
            <div class="card-content">
              <div class="price">€0.00</div>
              <div class="price-description">
                līdz 20 <br>pierakstiem <br>mēnesī
              </div>
            </div>
            <router-link to="/register" style="text-decoration:none;color:var(--background-color);width: 100%;">
              <button class="primary-btn pricing-btn">
                Izmēģināt bez maksas
              </button>
            </router-link>
          </div>

          <div class="pricing-card">
            <div class="card-content">
              <div class="price">€4.99</div>
              <div class="price-description">
                līdz 100 <br>pierakstiem <br>mēnesī
              </div>
            </div>
            <router-link to="/register" style="text-decoration:none;color:var(--background-color);width: 100%;">
              <button class="primary-btn pricing-btn">
                Izmēģināt bez maksas
              </button>
            </router-link>
          </div>

          <div class="pricing-card">
            <div class="card-content">
              <div class="price">€9.99</div>
              <div class="price-description">
                līdz 300 <br>pierakstiem <br>mēnesī
              </div>
            </div>
            <router-link to="/register" style="text-decoration:none;color:var(--background-color);width: 100%;">
              <button class="primary-btn pricing-btn">
                Izmēģināt bez maksas
              </button>
            </router-link>
          </div>
        </div>
      </section>

      <!-- Features Grid Section -->
      <section class="all-features-section">
        <div class="all-features-header">
          <h2>Viss, kas nepieciešams darbam</h2>
        </div>

        <!-- Desktop grid (3 columns, >1024px) -->
        <div class="all-features-grid all-features-grid--desktop">
          <div class="all-features-card" v-for="feature in features" :key="feature.name">
            <div class="all-features-icon">
              <component :is="feature.icon" />
            </div>
            <div class="all-features-text">
              <p class="all-features-name">{{ feature.name }}</p>
              <p class="all-features-desc">{{ feature.desc }}</p>
            </div>
          </div>
        </div>

        <!-- Tablet grid (2 columns, 769px–1024px) -->
        <div class="all-features-grid all-features-grid--tablet">
          <div class="all-features-card" v-for="feature in featuresTablet" :key="feature.name">
            <div class="all-features-icon">
              <component :is="feature.icon" />
            </div>
            <div class="all-features-text">
              <p class="all-features-name">{{ feature.name }}</p>
              <p class="all-features-desc">{{ feature.desc }}</p>
            </div>
          </div>
        </div>

        <!-- Mobile list (single column, ≤768px) -->
        <ul class="all-features-list">
          <li v-for="(feature, index) in featuresMobile" :key="feature.name">
            <span class="all-features-list-number">{{ String(index + 1).padStart(2, '0') }}</span>
            <div class="all-features-list-text">
              <span class="all-features-list-name">{{ feature.name }}</span>
              <span class="all-features-list-desc">{{ feature.desc }}</span>
            </div>
          </li>
        </ul>
      </section>

      <!-- FAQ Section -->
      <section class="faq-section" id="faq-section">
        <div class="faq-header">
          <h2>Biežāk uzdotie jautājumi</h2>
        </div>

        <div class="faq-container">
          <div class="faq-item" v-for="(faq, index) in faqs" :key="index" :class="{ 'active': openFaq === index }">
            <div class="faq-question" @click="toggleFaq(index)">
              <span>{{ faq.question }}</span>
              <PhCaretDown class="faq-caret" :class="{ 'rotated': openFaq === index }" />
            </div>
            <div class="faq-answer" v-show="openFaq === index">
              <p>{{ faq.answer }}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>

  <!-- Fifth Section: Footer -->
  <footer class="footer-section">
    <div class="footer-content">
      <!-- First Row -->
      <div class="footer-row first-row">
        <div class="footer-text-column">
          <h2>Vēlies <span style="color:var(--accent-color)">vairāk</span> pierakstu?</h2>
        </div>
        <div class="footer-button-column">
          <router-link to="/register" style="text-decoration:none;color:var(--main-color)">
            <button class="primary-btn footer-btn">
              Pievienojies
              <PhArrowRight class="button-icon-landing" style="color:var(--main-color)" />
            </button>
          </router-link>
        </div>
      </div>

      <!-- Separator Border -->
      <div class="footer-separator"></div>

      <!-- Second Row -->
      <div class="footer-row second-row">
        <div class="footer-copyright">
          <span>2026 © Appointum</span>
        </div>
        <div class="footer-nav">
          <a @click.prevent="goToSection('how-it-works')" href="#how-it-works" class="link-btn-no-underline"
            style="color: var(--background-color) !important; opacity: 0.7">
            Kā tas strādā
          </a>
          <a @click.prevent="goToSection('pricing')" href="#pricing" class="link-btn-no-underline"
            style="color: var(--background-color) !important; opacity:0.7">
            Cenas
          </a>
          <a @click.prevent="goToSection('faq-section')" href="#faq-section" class="link-btn-no-underline"
            style="color: var(--background-color) !important; opacity:0.7">
            BUJ
          </a>
          <router-link to="/contact-us" class="link-btn-no-underline"
            style="color: var(--background-color) !important; opacity:0.7">
            Kontakti
          </router-link>
        </div>
        <div class="footer-social">
          <a href="https://www.instagram.com/appointum_app/" target="_blank" class="instagram-link">Instagram</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import NavigationBar from './NavigationBar.vue';
import {
  PhArrowDown,
  PhLink,
  PhArrowRight,
  PhCaretDown,
  PhEnvelopeSimple,
  PhUser,
  PhCheck,
  PhCalendarBlank,
  PhUsers,
  PhUsersThree,
  PhClock,
  PhCreditCard,
  PhDeviceMobile,
  PhLockKey,
  PhInfo
} from '@phosphor-icons/vue';

export default {
  name: 'AppointumLanding',
  components: {
    NavigationBar,
    PhArrowDown,
    PhLink,
    PhArrowRight,
    PhCaretDown,
    PhEnvelopeSimple,
    PhUser,
    PhCheck,
    PhCalendarBlank,
    PhUsers,
    PhUsersThree,
    PhClock,
    PhCreditCard,
    PhDeviceMobile,
    PhLockKey,
    PhInfo
  },
  data() {
    return {
      openFaq: null,
      features: [
        {
          icon: 'PhCalendarBlank',
          name: 'Pierakstu kalendārs',
          desc: 'Dienas, nedēļas un mēneša kalendāra skats ar visu darba grafiku vienuviet.'
        },
        {
          icon: 'PhClock',
          name: 'Darba laiku iestatīšana',
          desc: 'Pievieno regulārus darba laikus vai katrai kalendārajai dienai individuālus.'
        },
        {
          icon: 'PhUsers',
          name: 'Komandas pārvaldība',
          desc: 'Uzaicini kolēģus un pārvaldiet pierakstus kopā, vienotā biznesa kontā.'
        },
        {
          icon: 'PhUsersThree',
          name: 'Grupu nodarbības',
          desc: 'Organizē vienreizējas vai regulāras grupu nodarbības un meistarklases.'
        },
        {
          icon: 'PhLockKey',
          name: 'Pieraksti tikai esošajiem klientiem',
          desc: 'Pieņem tiešsaistes pierakstus tikai no klientiem, kas jau ir saglabāti Tavā biznesa kontā.'
        },
        {
          icon: 'PhDeviceMobile',
          name: 'Mobilā versija',
          desc: 'Appointum pilnvērtīgi darbojas gan no datora, gan telefona un planšetes.'
        },
        {
          icon: 'PhCreditCard',
          name: 'Abonementi',
          desc: 'Veido abonementus un piešķir tos klientiem vienkāršā un pārskatāmā veidā.'
        },
        {
          icon: 'PhEnvelopeSimple',
          name: 'E-pasta atgādinājumi',
          desc: 'Klienti saņem automātiskus apstiprinājumus un atgādinājumus, mazinot aizmiršanas gadījumus.'
        },
        {
          icon: 'PhInfo',
          name: 'Personisks lietotāju atbalsts',
          desc: 'Mēs rūpējamies, lai darba uzsākšana ar sistēmu noritētu gludi, un izskatām visus lietotāju iesūtītos ieteikumus.'
        }
      ],
      faqs: [
        {
          question: 'Kam ir paredzēta šī aplikācija?',
          answer: 'Aplikācija ir paredzēta ikvienam, pie kā ir iespējams veikt pierakstus - frizieriem, masieriem, konsultantiem, treneriem, frīlanseriem un citu jomu pārstāvjiem. Tajā iespējams veidot gan individuālus pierakstus vienam klientam, gan grupu nodarbības.'
        },
        {
          question: 'Vai aplikācijā varu sadarboties ar saviem kolēģiem?',
          answer: 'Jā, aplikācijas sadaļā "Komanda" Tu vari uzaicināt kolēģus, ar kuriem kopā pārvaldīt pierakstus.'
        },
        {
          question: 'Ar ko Appointum atšķiras no citām pierakstu sistēmām?',
          answer: 'Appointum ir veidots solo profesionāļiem un mazām komandām, bez sarežģītas, tikai lielajiem saloniem nepieciešamas funkcionalitātes. Tādēļ Appointum ir ātrs, intuitīvs, un pēc reģistrācijas sekojot ceļveža soļiem, darbam būs sagatavots dažu minūšu laikā.'
        },
        {
          question: 'Kas notiks, kad aplikācijā tiks ieviesta maksa?',
          answer: 'Visi lietotāji tiks informēti par maksas plānu ieviešanu vismaz 2 nedēļas iepriekš. Esošie konti tiks automātiski pievienoti bezmaksas plānam, kas nodrošina 20 pierakstu izveidošanu ik mēnesi. Lietotājiem, kuriem būs nepieciešams vairāk pierakstu, būs patstāvīgi jāpievienojas kādam no maksas plāniem.'
        },
        {
          question: 'Mani interesē šī aplikācija, bet tajā nav pieejama viena man svarīga funkcija...',
          answer: 'Aplikācija ir jauna un tiek aktīvi pilnveidota. Ja neredzi kādu Tev nepieciešamu funkciju, dod mums ziņu - iespējams, ka tā ietilpst mūsu plānos. Mēs rūpīgi izskatām lietotāju ierosinājumus un regulāri iekļaujam tos nākamajās versijās. Sazinies ar mums support@appointum.com'
        }
      ]
    }
  },
  computed: {
    featuresTablet() {
      // Reorder for 2-column tablet layout.
      // 0=Kalendars, 1=Darba laiki, 2=Komanda, 3=Grupu nodarbibas,
      // 4=Tikai esosie, 5=Mobila, 6=Abonementi, 7=E-pasts, 8=Atbalsts
      const order = [0, 1, 3, 4, 6, 5, 7, 8, 2];
      return order.map(i => this.features[i]);
    },
    featuresMobile() {
      // 0=Kalendars, 1=Darba laiki, 2=Komanda, 3=Grupu nodarbibas,
      // 4=Tikai esosie, 5=Mobila, 6=Abonementi, 7=E-pasts, 8=Atbalsts
      const order = [0, 1, 3, 6, 4, 7, 2, 5, 8];
      return order.map(i => this.features[i]);
    }
  },
  methods: {
    toggleFaq(index) {
      this.openFaq = this.openFaq === index ? null : index;
    },
    goToSection(sectionId) {
      if (this.$route.path === '/') {
        this.scrollToSection(sectionId);
      } else {
        this.$router.push({ path: '/', hash: `#${sectionId}` }).then(() => {
          this.$nextTick(() => {
            setTimeout(() => {
              this.scrollToSection(sectionId);
            }, 100);
          });
        });
      }
    },
    scrollToSection(sectionId) {
      this.$nextTick(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    },
  }
}
</script>

<style scoped>
.landing-container {
  margin: 0 auto;
  color: var(--text-color-primary);
}

/* First Section - Hero (centered) */
.hero {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 60px 20px 0 20px;
  min-height: 70vh;
}

.hero-content {
  max-width: 800px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.hero-content h1 {
  font-size: 80px;
  font-weight: 400;
  margin-bottom: 0;
  margin-top: 0;
}

.hero-content h2 {
  margin-bottom: 2rem;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0.5px;
}

.marker-underline {
  position: relative;
  display: inline-block;
}

.marker-underline::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 14px;
  width: 100%;
  height: 8px;
  background-color: var(--accent-color);
  z-index: -1;
  border-radius: 3px;
}

.primary-btn {
  padding: 24px 36px;
  font-size: 18px;
  font-weight: 400;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.primary-btn:hover {
  transform: translateY(-3px);
}

/* Second Section - Feature Blocks */
.features-section {
  width: 100%;
  padding-top: 4rem;
}

.feature-block {
  display: flex;
  width: 100%;
  height: 600px;
  margin-bottom: 60px;
}

.text-area-left {
  padding-right: 10rem;
}

.text-area-right {
  padding-left: 10rem;
}

.feature-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.feature-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background-color: var(--accent-color);
  border-radius: 16px;
}

.feature-icon svg {
  width: 24px;
  height: 24px;
  color: var(--text-color-primary2);
}

.feature-text h3 {
  font-size: 52px;
  font-weight: 500;
  margin-bottom: 1rem;
  margin-top: 20px;
  line-height: 1.1;
}

.feature-text p {
  margin-top: 0;
  font-size: 18px;
}

.feature-visual {
  flex: 1;
  height: 600px;
  border-radius: 32px;
}

.bg-gray {
  background: linear-gradient(to bottom, #fec35e5e, var(--background-color));
}

.bg-blue {
  background: linear-gradient(to bottom, #fec35e5e, var(--background-color));
}

.bg-green {
  background: linear-gradient(to bottom, #fec35e5e, var(--background-color));
}

.bg-purple {
  background: linear-gradient(to bottom, #fec35e5e, var(--background-color));
}

.illustration {
  padding: 5rem 2rem;
  max-width: 500px;
  display: block;
  margin: 0 auto;
}

/* Third Section - CTA */
.cta-container {
  padding-top: 4rem;
}

.cta-section {
  background: linear-gradient(to right, #fec35e5e, #590a575e);
  padding: 2rem 4rem;
  text-align: left;
  min-height: 250px;
  border-radius: 24px;
  display: flex;
  gap: 40px;
  align-items: center;
}

.cta-content {
  flex: 1;
}

.cta-button-column {
  width: 200px;
  flex-shrink: 0;
}

.cta-content h1 {
  font-size: 80px;
  font-weight: 500;
  margin-top: 0;
  margin-bottom: 2rem;
}

.cta-content p,
.contact-us-link {
  font-size: 20px;
}

.cta-p-last {
  margin-bottom: 3rem;
}

/* Fourth Section - Pricing */
.pricing {
  text-align: center;
  padding: 4rem 0;
}

.pricing h2 {
  font-size: 52px;
  margin-bottom: 0;
  margin-top: 0;
  font-weight: 500;
}

.pricing-subtitle {
  font-size: 1.1rem;
  color: var(--text-color-secondary);
  margin-bottom: 40px;
  margin-top: 0;
}

.pricing-cards {
  display: flex;
  gap: 20px;
  margin-bottom: 40px;
  width: 100%;
}

.pricing-card {
  background: var(--background-table);
  border-radius: 24px !important;
  padding: 30px 24px;
  flex: 1;
  height: 180px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.pricing-card>a {
  display: flex;
  justify-content: center;
  align-items: center;
}

.pricing-card.first {
  background-color: transparent;
  border: 1px solid var(--main-color);
}

.card-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  flex: 1;
}

.price {
  font-size: 52px;
  font-weight: 400;
  line-height: 1;
}

.price-description {
  font-size: 14px;
  color: var(--text-color-secondary);
  text-align: left;
  line-height: 1.1;
}

.pricing-btn {
  padding: 16px 20px;
  width: 100%;
}

/* All Features Section */
.all-features-section {
  padding: 4rem 0 6rem 0;
}

.all-features-header {
  text-align: center;
  margin-bottom: 2.5rem;
}

.all-features-header h2 {
  font-size: 52px;
  font-weight: 500;
  margin: 0 0 0.75rem;
}

.all-features-subtitle {
  font-size: 18px;
  color: var(--text-color-secondary);
  margin: 0;
  line-height: 1.5;
}

.all-features-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.all-features-card {
  background: transparent;
  border-radius: 20px;
  padding: 1.25rem 1.5rem;
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.all-features-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background-color: var(--accent-color);
  border-radius: 16px;
  flex-shrink: 0;
}

.all-features-icon svg {
  width: 24px;
  height: 24px;
  color: var(--text-color-primary2);
}

.all-features-name {
  font-size: 18px;
  font-weight: 500;
  margin: 0 0 5px;
  color: var(--text-color-primary);
}

.all-features-desc {
  font-size: 16px;
  color: var(--text-color-secondary);
  margin: 0;
  line-height: 1.5;
}

/* Tablet grid and mobile list — hidden on desktop */
.all-features-grid--tablet {
  display: none;
}

.all-features-list {
  display: none;
}

/* FAQ Section */
.faq-section {
  padding: 4rem 0;
  max-width: 800px;
  margin: 0 auto;
}

.faq-header {
  text-align: center;
  margin-bottom: 3rem;
}

.faq-header h2 {
  font-size: 52px;
  font-weight: 500;
  margin: 0;
}

.faq-container {
  width: 100%;
}

.faq-item {
  border-bottom: 1px solid var(--text-color-secondary);
}

.faq-item:first-child {
  border-top: 1px solid var(--text-color-secondary);
}

.faq-question {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 0;
  cursor: pointer;
  font-size: 18px;
  font-weight: 400;
  transition: all 0.3s ease;
  color: var(--text-color-primary) !important;
}

.faq-question:hover {
  color: var(--accent-color);
}

.faq-caret {
  width: 20px;
  height: 20px;
  transition: transform 0.3s ease;
  flex-shrink: 0;
  margin-left: 20px;
}

.faq-caret.rotated {
  transform: rotate(180deg);
}

.faq-answer {
  padding-bottom: 24px;
  animation: fadeIn 0.3s ease;
}

.faq-answer p {
  margin: 0;
  font-size: 16px;
  line-height: 1.6;
}

.faq-item.active {
  opacity: 1;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Fifth Section - Footer */
.footer-section {
  margin-top: 120px;
  background-color: var(--text-color-primary2);
  padding: 0;
  width: 100%;
  min-height: 500px;
}

.footer-content {
  display: flex;
  flex-direction: column;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
  height: 500px;
}

.footer-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.first-row {
  padding: 0 60px;
  height: 70%;
}

.footer-text-column {
  flex: 1;
}

.footer-text-column h2 {
  font-size: 80px;
  font-weight: 500;
  margin: 0;
  color: var(--background-color);
}

.footer-button-column {
  width: 200px;
  flex-shrink: 0;
}

.footer-btn {
  background-color: var(--accent-color);
  color: var(--main--color)
}

.footer-btn:hover {
  background-color: #ffcd78 !important;
}

.footer-separator {
  width: 100%;
  height: 1px;
  background-color: var(--background-color);
  opacity: 0.3;
}

.second-row {
  margin-top: 30px;
  padding: 0 60px;
}

.footer-copyright {
  width: 200px;
  flex-shrink: 0;
  text-align: left;
}

.footer-copyright span {
  color: var(--background-color);
  opacity: 0.7;
  font-size: 14px;
}

.footer-nav {
  flex: 1;
  display: flex;
  justify-content: center;
  gap: 40px;
}

.footer-nav span {
  color: var(--background-color);
  opacity: 0.7;
  font-size: 16px;
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.footer-nav span:hover {
  opacity: 1;
}

.footer-social {
  width: 200px;
  flex-shrink: 0;
  text-align: right;
}

.instagram-link {
  color: var(--background-color);
  opacity: 0.7;
  text-decoration: none;
  font-size: 16px;
  transition: opacity 0.3s ease;
}

.instagram-link:hover {
  opacity: 1;
}

/* Responsive Design */
@media (max-width: 1440px) and (min-width: 1024px) {
  .text-area-left {
    padding-right: 8rem;
  }

  .text-area-right {
    padding-left: 8rem;
  }

  .cta-content h1 {
    font-size: 4rem;
    line-height: 1;
  }

  .cta-content p,
  .contact-us-link {
    font-size: 18px;
  }

  .footer-text-column h2 {
    font-size: 4.5rem;
  }
}

@media (max-width: 1024px) and (min-width: 769px) {
  .pricing-cards {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
    gap: 20px;
    max-width: 600px;
    margin: 0 auto 40px auto;
  }

  .pricing-card:first-child {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
  }

  .pricing-card:nth-child(2) {
    grid-column: 2 / 2;
    grid-row: 1 / 2;
  }

  .pricing-card:nth-child(3) {
    grid-column: 1 / 3;
    grid-row: 2 / 3;
    max-width: 290px;
    margin: 0 auto;
  }

  .text-area-left {
    padding-right: 3rem;
  }

  .text-area-right {
    padding-left: 3rem;
  }

  .cta-content h1 {
    font-size: 4rem;
    line-height: 1;
  }

  .cta-content p,
  .contact-us-link {
    font-size: 18px;
  }

  .footer-text-column h2 {
    font-size: 4.5rem;
  }

  .all-features-grid--desktop {
    display: none;
  }

  .all-features-grid--tablet {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .hero {
    padding: 0 20px;
    min-height: 80dvh;
    min-height: 80vh;
  }

  .marker-underline::after {
    display: none;
  }

  .features-section {
    padding-top: 2rem;
  }

  .feature-block {
    flex-direction: column;
    height: auto;
    margin-bottom: 40px;
    gap: 20px;
  }

  .feature-block:nth-child(even) {
    flex-direction: column-reverse;
  }

  .feature-text {
    flex: none;
    min-height: auto;
    padding: 0 10px;
  }

  .feature-visual {
    flex: none;
    height: 400px;
    min-height: 400px;
    margin: 0 10px;
  }

  .feature-text h3 {
    font-size: 2.2rem;
    line-height: 1.1;
    margin-bottom: 0.8rem;
    margin-top: 15px;
  }

  .feature-text p {
    font-size: 16px;
    line-height: 1.5;
    margin-bottom: 0;
  }

  .text-area-left,
  .text-area-right {
    padding: 0;
  }

  .feature-icon {
    width: 40px;
    height: 40px;
    border-radius: 12px;
  }

  .feature-icon svg {
    width: 20px;
    height: 20px;
  }

  .cta-section {
    flex-direction: column;
    text-align: center;
    padding: 4rem 2rem;
    min-height: auto;
    gap: 0;
  }

  .cta-content {
    flex: none;
  }

  .cta-content h1 {
    font-size: 3.3rem;
    margin-bottom: 1.5rem;
    line-height: 1;
  }

  .cta-content p,
  .contact-us-link {
    font-size: 1.1rem;
    margin-bottom: 1rem;
    line-height: 1.5;
  }

  .cta-p-last {
    margin-bottom: 3rem !important;
  }

  .cta-button-column {
    width: 100%;
    margin-top: 0;
    display: flex;
    justify-content: center;
  }

  .cta-button-column .primary-btn {
    width: auto;
    min-width: 160px;
  }

  .pricing-cards {
    flex-direction: column;
    align-items: center;
  }

  .pricing-card {
    height: auto;
    min-height: 180px;
    width: 80%;
    max-width: 300px;
  }

  .card-content {
    flex-direction: column;
    gap: 15px;
  }

  .price-description br {
    display: none;
  }

  .price-description {
    text-align: center;
    white-space: nowrap;
  }

  .all-features-section {
    padding: 2rem 0;
  }

  .all-features-header h2 {
    font-size: 3rem;
  }

  .all-features-subtitle {
    font-size: 16px;
  }

  /* Hide both grids, show plain list on mobile */
  .all-features-grid--desktop,
  .all-features-grid--tablet {
    display: none;
  }

  .all-features-list {
    display: block;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .all-features-list li {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    padding: 1rem 0;
  }

  .all-features-list-number {
    font-size: 28px;
    font-weight: 400;
    color: var(--accent-color);
    line-height: 1;
    flex-shrink: 0;
    width: 36px;
  }

  .all-features-list-text {
    flex: 1;
  }

  .all-features-list-name {
    font-size: 16px;
    font-weight: 500;
    color: var(--text-color-primary);
    text-align: left;
    display: block;
    margin: 0 0 5px;
  }

  .all-features-list-desc {
    font-size: 14px;
    color: var(--text-color-secondary);
    line-height: 1.5;
    text-align: left;
    margin: 0;
    display: block;
  }

  .faq-section {
    padding: 4rem 20px;
  }

  .faq-header h2 {
    font-size: 3rem;
  }

  .faq-question {
    font-size: 16px;
    padding: 20px 0;
  }

  .footer-content {
    height: auto;
    min-height: 500px;
  }

  .footer-row {
    flex-direction: column;
    height: auto;
    padding: 40px 20px;
  }

  .first-row {
    text-align: center;
    gap: 30px;
    padding: 40px 20px;
  }

  .footer-text-column h2 {
    font-size: 3.5rem;
    margin-bottom: 20px;
  }

  .footer-button-column {
    width: auto;
  }

  .second-row {
    flex-direction: column;
    gap: 20px;
    text-align: center;
    padding: 20px;
  }

  .footer-copyright,
  .footer-social {
    width: auto;
    text-align: center;
  }

  .footer-nav {
    order: 1;
    flex-direction: column;
    gap: 15px;
  }

  .footer-social {
    order: 2;
    width: auto;
    text-align: center;
  }

  .footer-copyright {
    order: 3;
    width: auto;
    text-align: center;
  }

  .hero-content h1 {
    font-size: 2.75rem;
    font-weight: 500;
  }

  .hero-content h2 {
    font-size: 18px;
  }

  .illustration {
    padding-top: 3rem;
  }
}

@media (max-width: 480px) {
  .feature-text {
    padding: 0;
  }

  .feature-text h3 {
    font-size: 1.8rem;
  }

  .feature-visual {
    height: 400px;
    min-height: 400px;
    margin: 0;
  }

  .feature-block {
    margin-bottom: 30px;
    gap: 8px;
  }

  .cta-content h1 {
    line-height: 2.75rem;
    font-size: 2.75rem;
    margin-bottom: 1.5rem;
  }

  .cta-content p {
    line-height: 20px;
  }

  .pricing-header h2 {
    font-size: 3rem;
    line-height: 1;
  }

  .all-features-header h2 {
    font-size: 2.2rem;
  }

  .faq-header h2 {
    font-size: 2.5rem;
  }

  .illustration {
    padding: 2.25rem;
  }

  .hero {
    padding: 0;
    padding-top: 3rem;
    min-height: calc(100dvh - 300px);
    min-height: calc(100vh - 300px);
  }

  .hero-content h1 {
    line-height: 2.75rem;
  }

  .hero-content h2 {
    line-height: 1.4;
    margin-top: 40px;
  }

  .cta-section {
    padding: 2rem;
  }

  .pricing-card {
    padding: 0 2rem 2rem 2rem;
  }

  .pricing {
    padding-bottom: 0;
  }

  .faq-section {
    padding: 2rem 0;
  }

  .footer-section {
    margin-top: 40px;
  }

  .footer-text-column h2 {
    margin-bottom: 0;
  }
}
</style>